import zod from 'zod';

export function collectZodError<Output>(input: zod.ZodType<Output>) {
  return (data: unknown) => {
    const result = input.safeParse(data);

    return result.success ? null : result.error.flatten((x) => x.message).formErrors[0];
  };
}

const commons = {
  email_invalid: 'fields.email_invalid',
  email_required: 'fields.email_required',

  display_name_invalid: 'fields.display_name_invalid',
  display_name_required: 'fields.display_name_required',

  password_invalid: 'fields.password_invalid',
  password_required: 'fields.password_required',

  space_name_required: 'fields.space_name_required',
  space_name_invalid: 'fields.space_name_invalid',
};

const makeValidate =
  <Output>(input: zod.ZodType<Output>) =>
  (t: any) =>
  (val: unknown) => {
    const r = collectZodError(input)(val);

    return r ? t(r as any) : null;
  };

export const RULES = {
  email: makeValidate(
    zod
      .string()
      .min(1, {
        message: commons.email_required,
      })
      .email(commons.email_invalid)
  ),
  password: makeValidate(
    zod.string().min(1, {
      message: commons.password_required,
    })
  ),
  privacy_checked: makeValidate(
    zod.boolean().refine((bool) => bool === true, {
      message: 'fields.privacy_required',
    })
  ),
  display_name_create: makeValidate(
    zod
      .string()
      .min(1, {
        message: commons.display_name_required,
      })
      .max(30, {
        message: commons.display_name_invalid,
      })
  ),
  password_create: makeValidate(
    zod
      .string()
      .min(1, {
        message: commons.password_required,
      })
      .refine((str) => /^(?=.*\d)(?=.*[a-zA-Z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{8,}$/.test(str), commons.password_invalid)
  ),
  space_name: makeValidate(
    zod
      .string()
      .min(1, {
        message: commons.space_name_required,
      })
      .max(30, {
        message: commons.space_name_invalid,
      })
  ),
};
